import React from "react";
import "../../style/frame.css";

const Frames = () => {
  return (
    <div className="col-md-8 col-lg-8 col-xl-8">
    <h1 className="mb-3 fw-normal border-bottom text-left pb-2 mb-4">
        Frames
      </h1>

      <p>
        Sample Iframe page There are 2 Iframes in this page. Use browser
        inspector to check the HTML source. You can switch between the parent
        frame and the two frames below.
      </p>


      <h2>Iframe 1</h2>
      <div className="iframe-scroll">
        <iframe
          src="new-tab-sample.php"
          title="iframe1"
          className="frame"
        ></iframe>
      </div>

      <h2 className="mt-5">Iframe 2</h2>
      <div className="iframe-scroll small-frame">
        <iframe
          src="new-tab-sample.php"
          title="iframe2"
          className="frame"
        ></iframe>
      </div>
    </div>
  );
};

export default Frames;